// src/stores/useWellSelectionStore.js
import { create } from "zustand";

export const useWellSelectionStore = create((set) => ({
  selected: null,

  selectWell: (w) => {
    set({ selected: w });
  },

  clearWell: () => set({ selected: null })
}));